import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DarkModeService } from '../dark-mode.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ButtonModule,
    AvatarModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  isDarkMode: boolean = false;
  userDetails: any;
  searchValue: string = '';
  userName: any;
  profilePhtotoUrl = environment.profilePhtotoUrl;
  Title: string = environment.appName;

  isSearchVisible: boolean = false;
  isMobileView: boolean = false;
  @Input() productName: string = environment.appName;
  searchControl: FormControl = new FormControl('');
  notificationCount: number = 11;
  @Input() placeholder: string = 'Search';

  constructor(
    private http: HttpClient,
    private darkModeService: DarkModeService,
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobileView = window.innerWidth < 768;
    //console.log(this.isMobileView); // Debugging
  }

  ngOnInit() {
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });
    this.searchControl.valueChanges.subscribe((value: string) => {
      this.onSearch(value);
    });
  }

  // Emit the event to toggle sidebar
  // onToggleSidebar() {
  //   console.log('Header icon clicked'); // Debugging log
  //   this.toggleSidebarEvent.emit(); // Emit the toggle event to parent
  // }
  onSearch(value: string): void {
    console.log('Search value:', value);
  }

  toggleDarkMode(): void {
    // Toggle dark mode class on the body or root element
    this.darkModeService.toggleDarkMode();
  }

  toggleSearch() {
    this.isSearchVisible = !this.isSearchVisible;

    if (this.isMobileView && this.isSearchVisible) {
      this.hideElementsForMobileSearch();
    } else {
      this.showElementsForMobileSearch();
    }
  }

  private hideElementsForMobileSearch() {
    const elementsToHide = [
      '.product-info',
      '.notification-icon',
      '.theme-toggle',
      '.avatar-wrapper',
    ];

    elementsToHide.forEach((selector) => {
      const element = document.querySelector(selector) as HTMLElement | null;
      if (element) {
        element.style.display = 'none';
      }
    });
  }

  private showElementsForMobileSearch() {
    const elementsToShow = [
      '.product-info',
      '.notification-icon',
      '.theme-toggle',
      '.avatar-wrapper',
    ];

    elementsToShow.forEach((selector) => {
      const element = document.querySelector(selector) as HTMLElement | null;
      if (element) {
        element.style.display = '';
      }
    });
  }

  clearSearch() {
    this.searchValue = '';
    this.isSearchVisible = !this.isSearchVisible;

    if (this.isMobileView && this.isSearchVisible) {
      this.hideElementsForMobileSearch();
    } else {
      this.showElementsForMobileSearch();
    }
  }
}
